import { useContext } from 'react';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { SummarySection } from './SummarySection';
import {
  SummarySectionContainer,
  SummaryOption,
  SummaryContainer,
  SummaryTitle,
} from './styles/SummarySections.styled';
import { EmployeeVacationDays } from '../../../../tabs/models/SummaryInterfaces';
import { LoadingSpinner } from 'src/components/common/LoadingSpinner/LoadingSpinner';
import {
  generateReactKey,
  KeyRoots,
} from 'src/utils/generateUniqueReactKey/generateUniqueReactKey';

interface SummaryWidgetProps {
  vacationPeriod: EmployeeVacationDays;
  loadingVacationPeriod: boolean;
}

export const SummaryWidget = ({
  vacationPeriod,
  loadingVacationPeriod,
}: SummaryWidgetProps) => {
  const { isMobile } = useContext(TeamsFxContext);
  const paidDaysOptions = {
    Deposited: vacationPeriod?.new_depositedbasepaiddays || 0,
    Used: vacationPeriod?.new_usedbasepaiddays || 0,
    Requested: vacationPeriod?.new_requestedbasepaiddays || 0,
    Remaining: vacationPeriod?.new_remainingbasepaiddays || 0,
  };
  const depositedDaysOptions = {
    Deposited: vacationPeriod?.new_depositedbonuspaiddays || 0,
    Used: vacationPeriod?.new_usedbonuspaiddays || 0,
    Requested: vacationPeriod?.new_requestedbonuspaiddays || 0,
    Remaining: vacationPeriod?.new_remainingbonuspaiddays || 0,
  };

  const MobileView = () => {
    return (
      <SummaryContainer>
        {loadingVacationPeriod ? (
          <LoadingSpinner />
        ) : (
          <>
            <SummaryTitle>
              <SummarySectionContainer>
                <p>Paid Days</p>
                {Object.entries(paidDaysOptions).map(([key, value], index) => (
                  <SummaryOption
                    key={generateReactKey(
                      KeyRoots.TIME_OFF_SUMMARY_SECTION_PAYED_DAYS,
                      index
                    )}
                  >
                    <p>{value}</p>
                    <p>{key}</p>
                  </SummaryOption>
                ))}
              </SummarySectionContainer>
            </SummaryTitle>
            <SummaryTitle>
              <SummarySectionContainer>
                <p>Bonus Days</p>
                {Object.entries(depositedDaysOptions).map(
                  ([key, value], index) => (
                    <SummaryOption
                      key={generateReactKey(
                        KeyRoots.TIME_OFF_SUMMARY_SECTION_BONUS_DAYS,
                        index
                      )}
                    >
                      <p>{value}</p>
                      <p>{key}</p>
                    </SummaryOption>
                  )
                )}
              </SummarySectionContainer>
            </SummaryTitle>
          </>
        )}
      </SummaryContainer>
    );
  };

  const DesktopView = () => {
    return (
      <>
        <SummaryContainer>
          <SummaryTitle>Paid Days</SummaryTitle>
          <SummarySection
            options={paidDaysOptions}
            loadingVacationPeriod={loadingVacationPeriod}
          />
          <SummaryTitle>Bonus Days</SummaryTitle>
          <SummarySection
            options={depositedDaysOptions}
            loadingVacationPeriod={loadingVacationPeriod}
          />
        </SummaryContainer>
      </>
    );
  };

  return isMobile ? <MobileView /> : <DesktopView />;
};
